import { Locale } from '@/shared/types';

import enUS from './en-US.json';
import ruRU from './ru-RU.json';

type Translations = {
  [LocaleKey in Locale]: {
    [message: string]: string;
  };
};

export const landingTranslations: Translations = {
  'en-US': enUS,
  'ru-RU': ruRU,
};
